import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { ClienteShort } from 'src/app/model/datos-maestros/cliente-short';
import { Pagination } from 'src/app/model/interfaces/pagination';

@Component({
  selector: 'app-busqueda-cliente',
  templateUrl: './busqueda-cliente.component.html',
  styleUrls: ['./busqueda-cliente.component.css']
})
export class BusquedaClienteComponent implements OnInit {

  @Output() onSelect = new EventEmitter<ClienteShort>();

  display: boolean = false;
  clientes: ClienteShort[] = [];
  loading: boolean = false;
  totalRecords: number = 0;

  // Filtros
  filterNombre: string = '';
  filterRuc: string = '';

  // Paginación actual
  currentPage: number = 0;
  pageSize: number = 10;

  constructor(private datosMaestrosService: DatosMaestrosService) { }

  ngOnInit(): void {
  }

  showDialog() {
    this.display = true;
    this.resetFilters();
    // Opcional: Cargar datos iniciales
    // this.search();
  }

  closeDialog() {
    this.display = false;
  }

  resetFilters() {
    this.filterNombre = '';
    this.filterRuc = '';
    this.clientes = [];
    this.totalRecords = 0;
  }

  search() {
    this.currentPage = 0; // Resetear a la primera página en nueva búsqueda
    this.loadData(0, this.pageSize);
  }

  loadCustomersLazy(event: LazyLoadEvent) {
    // PrimeNG envía 'first' como el índice del primer registro (0, 10, 20...)
    // Nuestra API espera número de página (0, 1, 2...)
    const page = event.first! / event.rows!;
    this.pageSize = event.rows!;
    this.loadData(page, this.pageSize);
  }

  loadData(page: number, pageSize: number) {
    this.loading = true;

    let query = '';
    let type: 'nombre' | 'ruc' = 'nombre';

    if (this.filterRuc) {
      query = this.filterRuc;
      type = 'ruc';
    } else if (this.filterNombre) {
      query = this.filterNombre;
      type = 'nombre';
    } else {
      // Si no hay filtros, no buscamos (o podríamos buscar todo si la API lo permite)
      this.loading = false;
      return;
    }
    console.log(this.filterRuc);
    const pagination: Pagination = {
      page: page,
      pageSize: pageSize
    };

    this.datosMaestrosService.searchClientes(query, type, pagination).subscribe(
      (response) => {
        //console.log(response);
        if (response.status === 'OK') {
          this.clientes = response.respuesta;
          //console.log(this.clientes);
          this.totalRecords = response.pagination.totalItems;
        } else {
          this.clientes = [];
          this.totalRecords = 0;
        }
        this.loading = false;
      },
      (error) => {
        console.error('Error buscando clientes', error);
        this.clientes = [];
        this.totalRecords = 0;
        this.loading = false;
      }
    );
  }

  selectCliente(cliente: ClienteShort) {
    this.onSelect.emit(cliente);
    this.closeDialog();
  }
}
